import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a Save icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/v6/icons/pen-to-square?f=classic&s=regular
 */
export const PenToSquareIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faPenToSquare} {...props} />;
};
